import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

// Configurer la persistance de l'authentification
setPersistence(auth, browserLocalPersistence)
  .catch((error) => {
    console.error('Erreur lors de la configuration de la persistance:', error);
  });

// Log de l'état d'authentification
auth.onAuthStateChanged((user) => {
    if (user) {
        console.log('Utilisateur connecté:', user.uid);
    } else {
        console.log('Utilisateur déconnecté');
    }
});
